import { Directive, ElementRef, EventEmitter, Output, OnInit } from '@angular/core';
import { ResizeSensor } from 'css-element-queries';
import { ResizedEvent } from './resized-event';

@Directive({
  standalone: false,
  selector: '[resized]'
})
export class ResizedDirective implements OnInit
{

  @Output() public readonly resized = new EventEmitter<ResizedEvent>();

  private oldWidth: number;
  private oldHeight: number;

  constructor(private readonly element: ElementRef)
  {
  }

  public ngOnInit(): void
  {
    new ResizeSensor(this.element.nativeElement, () => this.onResized());
    this.onResized();
  }

  private onResized(): void
  {
    const newWidth = this.element.nativeElement.clientWidth;
    const newHeight = this.element.nativeElement.clientHeight;

    if (newWidth === this.oldWidth && newHeight === this.oldHeight)
    {
      return;
    }

    const event = new ResizedEvent(
      this.element,
      newWidth,
      newHeight,
      this.oldWidth,
      this.oldHeight);

    this.oldWidth = this.element.nativeElement.clientWidth;
    this.oldHeight = this.element.nativeElement.clientHeight;

    this.resized.next(event);
  }
}
